// Module
var code = `<svg xmlns="http://www.w3.org/2000/svg" width="2.667" height="12" viewBox="0 0 2.667 12" fill="currentColor"><g fill-rule="evenodd"><path d="M1.334 4.667A1.333 1.333 0 110 6a1.333 1.333 0 011.334-1.333zM1.334 9.333A1.333 1.333 0 110 10.666a1.333 1.333 0 011.334-1.333zM1.334 0A1.333 1.333 0 110 1.333 1.333 1.333 0 011.334 0z"/></g></svg> `;
// Exports
module.exports = code;